import {
    Company,
    FormInput,
    FormRecord,
    Institution,
    LanguageCode,
    MapBoxAddress,
    MixedMedia,
    Principle,
    RCreateSoftwareBody,
    Software,
    Topic,
    TopicKnowledge
} from '@dh/types';

enum InstitutionProfileStep {
    Details,
    Images
}

enum CompanyProfileStep {
    Details,
    Images,
    Knowledge,
    Principles,
    Conditions,
    OpenSource // TODO: https://uxma.atlassian.net/browse/PRMA-155
}

interface InstitutionDetailsForm extends FormRecord {
    name: FormInput<string>;
    slogan: FormInput<string>;
    infoTitle: FormInput<string>;
    infoText: FormInput<string>;
    email: FormInput<string>;
    telephoneNumber: FormInput<string>;
    website: FormInput<string>;
    address: FormInput<MapBoxAddress>;
}

interface CompanyDetailsForm extends InstitutionDetailsForm {
    isPublic: FormInput<boolean>;
    services: FormInput<Topic[]>;
}
interface ImagesForm extends FormRecord {
    logo: FormInput<MixedMedia>;
    images: FormInput<MixedMedia[]>;
}

type InstitutionProfileForm = {
    [InstitutionProfileStep.Details]: InstitutionDetailsForm;
    [InstitutionProfileStep.Images]: ImagesForm;
};

type InstitutionStepForm = InstitutionDetailsForm | ImagesForm;
type CompanyStepForm =
    | CompanyDetailsForm
    | ImagesForm
    | CompanyKnowledgeForm
    | CompanyPrinciplesForm
    | CompanyConditionsForm
    | CompanyOpenSourceForm;

interface EditInstitutionStepProps<StepForm extends FormRecord> {
    institution: Institution;
    toggleSnackbar?: (value?: boolean | undefined) => void;
    form: StepForm;
    updateForm: (key: string, value: unknown) => void;
    updateErrorState: (key: string, hasError: boolean) => void;
}

interface CompanyDetailsForm extends InstitutionDetailsForm {
    isPublic: FormInput<boolean>;
    services: FormInput<Topic[]>;
}

interface CompanyKnowledgeForm extends FormRecord {
    topicsKnowledge: FormInput<TopicKnowledge[]>;
}

interface CompanyPrinciplesForm extends FormRecord {
    principles: FormInput<Principle[]>;
}

interface CompanyConditionsForm extends FormRecord {
    minBudget: FormInput<number>;
    languages: FormInput<LanguageCode[]>;
}

interface CompanyOpenSourceForm extends FormRecord {
    newSoftware: FormInput<RCreateSoftwareBody>;
    software: FormInput<Software[]>;
}

type CompanyProfileForm = {
    [CompanyProfileStep.Details]: CompanyDetailsForm;
    [CompanyProfileStep.Images]: ImagesForm;
    [CompanyProfileStep.Knowledge]: CompanyKnowledgeForm;
    [CompanyProfileStep.Principles]: CompanyPrinciplesForm;
    [CompanyProfileStep.Conditions]: CompanyConditionsForm;
    [CompanyProfileStep.OpenSource]: CompanyOpenSourceForm; // TODO: https://uxma.atlassian.net/browse/PRMA-155
};

interface EditCompanyStepProps<StepForm extends FormRecord> {
    company: Company;
    toggleSnackbar?: (value?: boolean | undefined) => void;
    form: StepForm;
    updateForm: (key: string, value: unknown) => void;
    updateErrorState: (key: string, hasError: boolean) => void;
}

export { InstitutionProfileStep, CompanyProfileStep };

export type {
    FormInput,
    EditInstitutionStepProps,
    EditCompanyStepProps,
    InstitutionProfileForm,
    InstitutionDetailsForm,
    CompanyDetailsForm,
    CompanyKnowledgeForm,
    CompanyConditionsForm,
    CompanyPrinciplesForm,
    CompanyOpenSourceForm,
    CompanyProfileForm,
    ImagesForm,
    FormRecord,
    InstitutionStepForm,
    CompanyStepForm
};
